import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NormatividadService } from 'src/app/servicios/normatividad.service';
import { Loading } from 'src/app/Class/Loading';
import { ActivatedRoute, Router } from '@angular/router';
import { Mensajes } from 'src/app/Class/mensajes';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-editar-detalle',
  templateUrl: './editar-detalle.component.html',
  styleUrls: ['./editar-detalle.component.css']
})
export class EditarDetalleComponent implements OnInit {
  public fundamentolegalcke = "";
  public considerandocke = "";
  public resuelveacuerdacke = "";
  public titulockeditor = "";
  public componentecke = "";
  public detalle: FormGroup;
  public selectElementos: any = [];
  public fieldArray: Array<any> = [];
  public elementos: FormGroup;
  public estructura_id: any;
  public norma_id: any;
  public id: any;
  public titulo: any;
  public interna:any;
  public tipo_norma: any;
  public norma: any;
  public elem_id: any;
  public considerando = "";
  public resuelveacuerda = "";
  public cuerpo = "";
  
  constructor(private normatividadService: NormatividadService, public loading: Loading, private activatedroute: ActivatedRoute, private form: FormBuilder, private router: Router) { 
    this.elem_id=0;
    this.loading.estado = true;
    this.activatedroute.queryParams.subscribe(params => { this.id = params['id']; });
    this.normatividadService.getDetalleHTMLNorma(this.id).subscribe(data => {
      if(data['success']){
        this.titulo  = data['norma']['titulo'];
        this.interna = data['norma']['interna'];
        this.tipo_norma = data['norma']['tipos_norma_id'];
        this.norma = data['norma']['tipos_norma_nombre'];
        this.considerando = data['norma']['considerando'];
        this.resuelveacuerda = data['norma']['resuelveacuerda'];
        this.cuerpo = data['norma']['cuerpo'];
        this.loading.estado = false;
      }else{
        this.loading.estado = false;
        Swal.fire({ type: 'error', title:'Error',  text: 'Norma no disponible',  showConfirmButton: false, timer: 1500 });
        this.router.navigate(['/dashboard']);
      }
    });
    this.normatividadService.getDatosSelect()
    .subscribe(data => {
      this.selectElementos = data['elementos'];
    });  
    this.detalle = this.form.group({
      unidad:[''],
      norma:[this.id, Validators.required],
      titulo:['', Validators.required],
      fundamento:[''],
      considerando:['', Validators.required],
      resuelveacuerda:['', Validators.required],
    });
    this.elementos = this.form.group({
      id:[''],
      estructura:  ['', Validators.required],
      norma: [this.id],
      numero: [''],
      valor:['', Validators.required],
      hijo:['', Validators.required],
      padre:[],
    });
  }

  ngOnInit() { }

  addFieldValue() { 
    this.fieldArray.push() 
  } 

  componentesNorma(){
    this.elementos.value['id']=this.elem_id;
    this.fieldArray.push(this.elementos.value);
    this.elem_id++;
    this.elementos.reset({norma: this.id});
    $('#modalItems').modal('hide');    
  }

  deleteFieldValue(index) { 
    this.fieldArray.splice(index, 1); 
  } 

  guardarDetalle(){
    debugger;
    var formData = new FormData();
    if (!this.detalle.valid && this.fieldArray.length>0) {
      Swal.fire({ type: 'error', title:'Error', text: 'Verifique los datos e intente nuevamente', showConfirmButton: false, timer: 1500 });
    }    
    else {
      
      for( var nombre in this.detalle.value ) { 
        formData.append(nombre, this.detalle.value[nombre]); 
      }
      var dataAux =[];
      for( var i=0; i<this.fieldArray.length;i++)
      {
        dataAux.push({
          estructura: this.fieldArray[i].estructura.id,
          norma: this.fieldArray[i].norma,
          numero: this.fieldArray[i].numero,
          valor: this.fieldArray[i].valor,
          hijo: this.fieldArray[i].hijo,
          padre: this.fieldArray[i].padre,
        });
      }
      formData.append("elementos", JSON.stringify(dataAux));
      this.normatividadService.guardarDetalleNorma(formData)
      .subscribe(data => {
        if(data['success'] == true){
          Swal.fire({ type: 'success',  showConfirmButton: false, timer: 1500 });
          this.router.navigate(['/normatividad/listadoNormas/'+this.tipo_norma]);
        }
        else{
          Swal.fire({ type: 'error', title:'Error', text: 'Los datos no fueron ingresados', showConfirmButton: false, timer: 1500});
        }
        this.loading.estado = false;      
      });
    }
  }

}
